import React, { useCallback, useEffect, useState } from "react";

const Calculator = () => {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");

  const handleClick = (value) => {
    setInput(input + value);
  };

  const handleClear = () => {
    setInput("");
    setResult("");
  };

  const handleBackspace = () => {
    setInput(input.slice(0, -1));
  };

  const handleCalculate = useCallback(() => {
    try {
      // eslint-disable-next-line no-eval
      setResult(eval(input).toString());
    } catch (error) {
      setResult("Error");
    }
  }, [input]);

    // Listen for the Enter key press to trigger calculation
    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Enter") {
          handleCalculate();
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
  
      // Clean up the event listener when the component is unmounted
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [handleCalculate, input]);

  return (
    <div className="bg-gray-100">
      <div className="w-64 p-2 bg-white rounded-lg shadow-lg">
        <div className="text-right mb-4">
          <div className="text-gray-600 text-lg h-8 bg-gray-100 rounded rounded-bl-none rounded-br-none px-2">{input}</div>
          <div className="text-2xl font-bold h-8 bg-gray-100 rounded rounded-tl-none rounded-tr-none px-2">{result}</div>
        </div>
        <div className="grid grid-cols-4 gap-2">
          {["7", "8", "9", "/", "4", "5", "6", "*", "1", "2", "3", "-", "0", ".", "=", "+"].map((value) => (
            <span
              key={value}
              onClick={() => handleClick(value)}
              className="p-2 bg-gray-200 rounded-lg text-lg font-bold text-center cursor-pointer"
            >
              {value}
            </span>
          ))}
          <span
            onClick={handleClear}
            className="col-span-2 p-2 bg-red-400 rounded-lg text-lg font-bold text-white text-center"
          >
            Clear
          </span>
          <span
            onClick={handleBackspace}
            className="col-span-2 p-2 bg-yellow-400 rounded-lg text-lg font-bold text-white text-center"
          >
            Backspace
          </span>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
